/* unplugin-vue-components disabled */import script from "./CinemaEmpty.vue?vue&type=script&lang=ts&setup=true"
export * from "./CinemaEmpty.vue?vue&type=script&lang=ts&setup=true"

import "./CinemaEmpty.vue?vue&type=style&index=0&id=56c5b760&lang=scss"

const __exports__ = script;

export default __exports__